<template>
  <div>
    <section-collapseable
      title="Users"
      button-text="Set Users"
      hide-button-icon
      @add="$refs.setUsersModal.open()"
      default-expanded
      hide-initial-always
    >
      <template v-slot:expanded>
        <template v-if="users.length">
          <app-avatar
            v-for="user in users"
            :key="user.id"
            :user-id="user.id"
            :size="30"
            class="mr-50"
          ></app-avatar>
        </template>
        <p v-else class="no_users">No user set</p>
      </template>
    </section-collapseable>

    <modal-container>
      <modal-default
        ref="setUsersModal"
        title="Set Users"
      >
        <b-field
          v-for="user in $store.getters.activeUsers"
          :key="user.id"
        >
          <b-checkbox
            v-model="form.user_ids"
            :native-value="user.id"
            size="is-small"
          >{{ user.full_name }}</b-checkbox>
        </b-field>

        <template v-slot:footer>
          <button-default
            @click="saveUsers"
            :loading="isSaving"
            :disabled="isSaving"
          >Save Users</button-default>
        </template>
      </modal-default>
    </modal-container>
  </div>
</template>

<script>
import SetUsers from "../components/SetUsers";
export default {
  name: "LeadUsers",
  components: {SetUsers},
  data() {
    return {
      isSaving: false,
      userIds: this.$store.state.activeRecord ? this.$utils.clone(this.$store.state.activeRecord.user_ids): null,
      form: {
          user_ids: [],
          lead_manager_id: null,
          acquisitions_manager_id: null,
          dispositions_manager_id: null,
          rehab_manager_id: null,
          transaction_coordinator_id: null,
      }
    }
  },
  created() {
    this.form = {
      user_ids: this.$utils.clone(this.$store.state.activeRecord.user_ids),
      lead_manager_id: this.record.lead_manager_id,
      acquisitions_manager_id: this.record.acquisitions_manager_id,
      dispositions_manager_id: this.record.dispositions_manager_id,
      rehab_manager_id: this.record.rehab_manager_id,
      transaction_coordinator_id: this.record.transaction_coordinator_id,
    }
  },
  computed: {
    record() {
      // If activeRecord is null then return necessary empty info
      return this.$store.state.activeRecord ? this.$store.state.activeRecord : {
        user_ids: [],
        lead_manager_id: null,
        acquisitions_manager_id: null,
        dispositions_manager_id: null,
        rehab_manager_id: null,
        transaction_coordinator_id: null,
      };
    },
    users() {
      return this.record.user_ids.map(id => {
        return this.$store.getters.users.find(user => user.id === id);
      });
    },
  },
  methods: {
    saveUsers() {
      this.isSaving = true;

      this.$api.records.changeUsers(this.record.record.id, this.form).then(() => {
        this.isSaving = false;
        this.$refs.setUsersModal.close();
      });
    },
  }
}
</script>

<style lang="scss" scoped>
@import "../../../styles/variables/variables";

.no_users {
  font-style: italic;
  color: $text-muted;
}
</style>
